(() => {
  if (customElements.get('sth-product-share')) return;
  class ProductShare extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('.sth-share__data').textContent);
      this.words = this.data.words;
      this.order = [];
      // Make sharing possible immediately with the cover photo selected.
      const firstPhoto = this.querySelector('[data-photo]');
      if (firstPhoto) { firstPhoto.checked = true; this.order.push(firstPhoto.dataset.photo); }
      this.files = [];
      this.urls = [];
      this.version = 0;
      this.status = this.querySelector('[data-status]');
      this.caption = this.querySelector('[data-caption]');
      this.variant = this.querySelector('[data-variant]');
      this.destination = this.querySelector('[data-destination]');
      this.format = this.querySelector('[data-format]');
      this.addEventListener('change', event => {
        if (event.target.matches('[data-photo]')) {
          const id = event.target.dataset.photo;
          this.order = this.order.filter(value => value !== id);
          if (event.target.checked) this.order.push(id);
          this.version++;
          this.clear();
          this.renderOrder();
        }
        this.update();
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-action]');
        if (!button) return;
        event.preventDefault();
        this.action(button.dataset.action, button);
      });
      this.renderOrder();
      this.update();
      // Price/size caption follows the actively selected variant when URL is updated.
      this.syncCurrentVariant = () => {
        const id = new URL(location.href).searchParams.get('variant');
        if (id && this.variant?.querySelector('option[value="' + id + '"]')) {
          this.variant.value = id; this.version++; this.clear(); this.update();
        }
      };
      document.addEventListener('variant:selected', this.syncCurrentVariant);
      document.addEventListener('variant:updated', this.syncCurrentVariant);
      window.addEventListener('popstate', this.syncCurrentVariant);
    }
    disconnectedCallback() {
      this.version++; this.clear();
      if (this.syncCurrentVariant) {
        document.removeEventListener('variant:selected', this.syncCurrentVariant);
        document.removeEventListener('variant:updated', this.syncCurrentVariant);
        window.removeEventListener('popstate', this.syncCurrentVariant);
      }
    }
    selectedVariant() { return this.data.variants.find(v => String(v.id) === this.variant.value) || this.data.variants[0]; }
    captionText() {
      const variant = this.selectedVariant();
      if (!variant) return this.data.title;
      const destination = this.destination?.value || 'instagram';
      const fmt = this.format?.value || 'post';
      const url = new URL(this.data.url);
      url.searchParams.set('variant', variant.id);
      const name = this.data.title;
      const option = variant.title !== 'Default Title' ? variant.title : '';
      let opening;
      if (destination === 'facebook') opening = 'SHOP TO HEAVEN | ' + name + '\nDiscover this piece for your next look.';
      else if (destination === 'instagram') opening = (fmt === 'story' ? 'Style find of the day: ' : 'SHOP TO HEAVEN EDIT | ') + name + '\nExplore the details and find your fit.';
      else if (destination === 'tiktok') opening = 'Fashion find: ' + name + '\nSee the style, colours and sizing before you shop.';
      else opening = 'SHOP TO HEAVEN | ' + name;
      const parts = [opening];
      if (option) parts.push('Selected: ' + option);
      parts.push(this.words.price + ': ' + variant.money);
      if (variant.compare > variant.price) parts.push(this.words.reference + ': ' + variant.compareMoney);
      for (const offer of this.data.offers) {
        const now = Date.now();
        if (now < Date.parse(offer.startsAt) || (offer.endsAt && now >= Date.parse(offer.endsAt))) continue;
        if (offer.variants.length && !offer.variants.includes(String(variant.id))) continue;
        parts.push(this.words.offer + ': ' + offer.text);
      }
      if (!variant.available) parts.push(this.words.unavailable);
      parts.push('View product: ' + url.href);
      parts.push(this.hashtags() + (destination === 'tiktok' ? ' #StyleFinds' : destination === 'instagram' ? ' #OutfitInspiration' : ''));
      return parts.join('\n\n');
    }
    hashtags() {
      const text = (this.data.title + ' ' + this.data.type).toLowerCase();
      const tags = ['ShopToHeaven'];
      const rules = [
        [/baby|newborn|infant|toddler/, ['BabyClothes', 'BabyStyle']],
        [/kids|children|boys|girls/, ['KidsFashion']],
        [/sneaker|shoe|footwear|boot|sandal/, ['Footwear', 'SneakerStyle']],
        [/handbag|tote|shoulder bag|backpack/, ['Bags', 'Accessories']],
        [/dress|skirt|women/, ['WomensFashion']],
        [/\bmen\b|mens|male/, ['MensFashion']],
        [/belt|sunglasses|jewellery|jewelry|watch/, ['Accessories']],
        [/shirt|trouser|pants|hoodie|jacket/, ['OutfitIdeas']]
      ];
      for (const [pattern, values] of rules) if (pattern.test(text)) tags.push(...values);
      tags.push('AustralianShopping');
      return [...new Set(tags)].slice(0, 6).map(t => '#' + t).join(' ');
    }
    update() {
      this.caption.value = this.captionText();
      const social = ['facebook', 'instagram', 'tiktok'].includes(this.destination.value);
      this.querySelector('[data-format-label]').hidden = !social;
      const guideKey = this.destination.value === 'facebook' ? 'fb_guide'
        : this.destination.value === 'tiktok' ? 'tiktok_guide'
        : this.destination.value === 'x' ? 'x_guide'
        : this.destination.value === 'email' ? 'email_guide'
        : social ? this.format.value + '_guide' : 'message_guide';
      this.querySelector('[data-guide]').textContent = this.words[guideKey];
      const send = this.querySelector('[data-action="send"]');
      send.textContent = this.words.send + ' — ' + this.destination.selectedOptions[0].textContent;
      if (this.files.length) {
        const payload = { files: this.files, title: this.data.title, text: this.captionText() };
        send.hidden = !(navigator.canShare?.(payload) || navigator.canShare?.({ files: this.files }));
      }
    }
    renderOrder() {
      for (const box of this.querySelectorAll('[data-photo]')) {
        const position = this.order.indexOf(box.dataset.photo);
        box.closest('label').querySelector('[data-number]').textContent = position < 0 ? '' : String(position + 1);
      }
      const preview = this.querySelector('[data-preview]');
      preview.replaceChildren();
      this.order.forEach((id, index) => {
        const box = this.querySelector('[data-photo="' + id + '"]');
        const figure = document.createElement('figure');
        const image = document.createElement('img');
        image.src = box.dataset.thumbnail; image.alt = this.data.title;
        const caption = document.createElement('figcaption');
        caption.textContent = (index + 1) + (index === 0 ? ' · ' + this.words.cover : '');
        figure.append(image, caption); preview.append(figure);
      });
      this.querySelector('[data-action="prepare"]').disabled = !this.order.length;
    }
    clear() {
      this.urls.forEach(url => URL.revokeObjectURL(url));
      this.urls = []; this.files = [];
      this.querySelector('[data-downloads]')?.replaceChildren();
      const send = this.querySelector('[data-action="send"]');
      if (send) send.hidden = true;
    }
    say(key) { this.status.textContent = this.words[key]; }
    async action(action, button) {
      if (action === 'reset') {
        this.querySelectorAll('[data-photo]').forEach(box => { box.checked = false; });
        this.order = []; this.version++; this.clear(); this.renderOrder(); return;
      }
      if (action === 'text') {
        if (!navigator.share) { this.say('unsupported'); return; }
        try { await navigator.share({ title: this.data.title, text: this.captionText() }); this.say('sent'); }
        catch (error) { this.say(error.name === 'AbortError' ? 'cancelled' : 'error'); }
        return;
      }
      if (action === 'copy') {
        try { await navigator.clipboard.writeText(this.captionText()); this.say('copied'); }
        catch (_) { this.caption.focus(); this.caption.select(); this.say('copy_error'); }
        return;
      }
      if (action === 'send') {
        if (this.destination.value === 'facebook') {
          const photoPayload = { files: this.files };
          if (!this.files.length || !navigator.canShare?.(photoPayload)) { this.say('unsupported'); return; }
          let copied = Promise.resolve(false);
          try { copied = navigator.clipboard.writeText(this.captionText()).then(() => true, () => false); } catch (_) {}
          try {
            await navigator.share(photoPayload);
            this.say(await copied ? 'fb_copied' : 'fb_copy_error');
          } catch (error) { this.say(error.name === 'AbortError' ? 'cancelled' : 'error'); }
          return;
        }
        const payload = { files: this.files, title: this.data.title, text: this.captionText() };
        const photoPayload = { files: this.files };
        if (!this.files.length || !(navigator.canShare?.(payload) || navigator.canShare?.(photoPayload))) { this.say('unsupported'); return; }
        let copied = Promise.resolve(false);
        try { copied = navigator.clipboard.writeText(this.captionText()).then(() => true, () => false); } catch (_) {}
        try {
          await navigator.share(navigator.canShare?.(payload) ? payload : photoPayload);
          this.say((await copied) ? 'sent' : 'copy_error');
        } catch (error) { this.say(error.name === 'AbortError' ? 'cancelled' : 'error'); }
        return;
      }
      if (action !== 'prepare') return;
      if (!this.order.length) { this.say('select'); return; }
      const chosen = this.order.map(id => this.querySelector('[data-photo="' + id + '"]'));
      this.clear(); const version = ++this.version; button.disabled = true; this.say('loading');
      try {
        const files = await Promise.all(chosen.map(async (box, index) => {
          const response = await fetch(box.value, { credentials: 'omit' });
          if (!response.ok) throw new Error('Photo fetch failed');
          const blob = await response.blob();
          if (!blob.type.startsWith('image/')) throw new Error('Not an image');
          const extension = blob.type === 'image/png' ? 'png' : blob.type === 'image/webp' ? 'webp' : 'jpg';
          return new File([blob], String(index + 1).padStart(2, '0') + '-' + this.data.handle + '.' + extension, { type: blob.type });
        }));
        if (version !== this.version || !this.isConnected) return;
        this.files = files;
        const downloads = this.querySelector('[data-downloads]');
        files.forEach((file, index) => {
          const url = URL.createObjectURL(file); this.urls.push(url);
          const link = document.createElement('a'); link.href = url; link.download = file.name;
          link.textContent = this.words.save + ' ' + (index + 1); downloads.append(link);
        });
        const preparedPayload = { files, title: this.data.title, text: this.captionText() };
        const canShare = navigator.canShare?.(preparedPayload) || navigator.canShare?.({ files });
        this.querySelector('[data-action="send"]').hidden = !canShare;
        this.say(canShare ? 'ready' : 'unsupported');
      } catch (error) { if (version === this.version) this.say('error'); }
      finally { button.disabled = !this.order.length; }
    }
  }
  customElements.define('sth-product-share', ProductShare);
})();
